import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { ChequeBookDetail, ChequeBookHeader } from "../../models/cheque-book-Header.model";
import { ChequeStatusKind } from "../../models/tresury.enums";

@Component({
  selector: "ngx-cheque-book-form",
  templateUrl: "./cheque-book-form.component.html",
  styleUrls: ["./cheque-book-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChequeBookFormComponent extends BaseFormComponent<ChequeBookHeader> {
  DefaultValues: Dictionary = [];
  ChequeBookDetails: form_control[];
  @ViewChild("chequeBook") public chequeBook: EditableGridComponent;
  erroremessage: string;
  _selectedChequeBookRow: ChequeBookDetail;
  constructor(private lookupservice: LookupService, protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.DefaultValues["ChequeBookHeaderId"] = 0;
    this.apiName = "ChequeBookHeader";
    this.label = "دسته چک";
    super.ngOnInit();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.ChequeBookDetails = undefined;
  }
  setColumnAttribute() {
    this.orignalColumns.forEach((x) => {
      if (x.name.includes("Password")) x.textType = "password";
      if (!x.disabled && (x.name === "DocumentNo" || x.name === "TotalSheet")) {
        x.disabled = this.model?.ChequeBookDetails?.length > 0;
        if (!this.isNewRow && this.formGroup && this.formGroup.controls[x.name]) this.formGroup.get(x.name).disable();
      }
    });
    if (this.formGroup) this.formGroup.updateValueAndValidity();
    this.ChequeBookDetails = this.getDetailControlModels("ChequeBookDetails");
    this.chequeBook?.setColumnWith();

    this.columns.forEach((x) => ((x.isFloat = null), (x.userClass = null)));
    this.cd.markForCheck();
  }
  isCreatable(): boolean {
    return (
      this.model?.ChequeBookDetails?.length > 0 ||
      !this.formGroup ||
      !this.formGroup.controls["DocumentNo"].value ||
      !this.formGroup.controls["TotalSheet"].value
    );
  }
  setdefault() {
    if (!this.model.ChequeBookDetails) this.model.ChequeBookDetails = [];
    if (!this.model.ReceiptDate) this.model.ReceiptDate = new Date();
    this.model.ChequeBookDetails = this.model.ChequeBookDetails.sort((a, b) => a.DocumentNo - b.DocumentNo);
    this.setColumnAttribute();
  }
  cancelChequeBook() {
    if (this._selectedChequeBookRow) {
      this.lookupservice
        .getLookupbyCode("TRS", "ChequeStatusKind", ChequeStatusKind.Canceled)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            if (this.chequeBook?.formGroup) {
              this.chequeBook.formGroup.controls["StatusKindId"].setValue(x.Id);
              this.chequeBook.formGroup.controls["StatusKindCode"].setValue(x.Code);
              this.chequeBook.formGroup.controls["StatusKindTitle"].setValue(x.Title);
            }
            this.model.ChequeBookDetails.find((x) => x.DocumentNo === this._selectedChequeBookRow.DocumentNo).StatusKindId = x.Id;
            this.model.ChequeBookDetails.find((x) => x.DocumentNo === this._selectedChequeBookRow.DocumentNo).StatusKindCode = x.Code;
            this.model.ChequeBookDetails.find((x) => x.DocumentNo === this._selectedChequeBookRow.DocumentNo).StatusKindTitle = x.Title;
            if (this.model.ChequeBookDetails.find((x) => x.DocumentNo === this._selectedChequeBookRow.DocumentNo).State === RowState.NoChange)
              this.model.ChequeBookDetails.find((x) => x.DocumentNo === this._selectedChequeBookRow.DocumentNo).State = RowState.Modify;
            this.setColumnAttribute();
          }
        });
    } else this.erroremessage = "هیچ چکی انتخاب نشده است.";
  }
  returnCancelChequeBook() {
    if (this._selectedChequeBookRow) {
      this.lookupservice
        .getLookupbyCode("TRS", "ChequeStatusKind", ChequeStatusKind.NotUsed)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            if (this.chequeBook?.formGroup) {
              this.chequeBook.formGroup.controls["StatusKindId"].setValue(x.Id);
              this.chequeBook.formGroup.controls["StatusKindCode"].setValue(x.Code);
              this.chequeBook.formGroup.controls["StatusKindTitle"].setValue(x.Title);
            }
            this.model.ChequeBookDetails.find((x) => x.DocumentNo === this._selectedChequeBookRow.DocumentNo).StatusKindId = x.Id;
            this.model.ChequeBookDetails.find((x) => x.DocumentNo === this._selectedChequeBookRow.DocumentNo).StatusKindCode = x.Code;
            this.model.ChequeBookDetails.find((x) => x.DocumentNo === this._selectedChequeBookRow.DocumentNo).StatusKindTitle = x.Title;
            if (this.model.ChequeBookDetails.find((x) => x.DocumentNo === this._selectedChequeBookRow.DocumentNo).State === RowState.NoChange)
              this.model.ChequeBookDetails.find((x) => x.DocumentNo === this._selectedChequeBookRow.DocumentNo).State = RowState.Modify;
          }
        });
    } else this.erroremessage = "هیچ چکی انتخاب نشده است.";
  }
  createChequeBook() {
    if (!this.isCreatable()) {
      this.model.ChequeBookDetails = [];
      this.lookupservice
        .getLookupbyCode("TRS", "ChequeStatusKind", ChequeStatusKind.NotUsed)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            for (let i = 0; i < this.formGroup.controls["TotalSheet"].value; i++) {
              let entity: ChequeBookDetail = <ChequeBookDetail>{};
              entity.DocumentNo = Number(this.formGroup.controls["DocumentNo"].value) + i;
              entity.Active = true;
              entity.ChequeBookHeaderId = this.model.Id;
              entity.State = RowState.New;
              entity.StatusKindId = x.Id;
              entity.StatusKindCode = x.Code;
              entity.StatusKindTitle = x.Title;
              this.model.ChequeBookDetails.push(entity);
              this.setColumnAttribute();
            }
          }
        });
    }
  }
  selectedChequeBookRow($event) {
    this._selectedChequeBookRow = $event;
  }
  isValid() {
    this.erroremessage = undefined;
    if (!this.model.ChequeBookDetails || this.model.ChequeBookDetails.length <= 0) {
      this.erroremessage = "هیچ قلمی برای دسته چک ایجاد نشده است.";
    }
    return !this.erroremessage;
  }
}
